import React, { useEffect, useRef, useState } from 'react';
import { mappls } from 'mappls-web-maps';

const AnimatedMap = ({ pathPoints }) => {
  const mapRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mapInstanceRef = useRef(null);
  const polylineRef = useRef(null);
  const mapplsInstanceRef = useRef(null);
  const accessToken = "onqfxjgqmpicvnzbuyyuctsmbwtdtopeogxd";

  // Default path points
  const defaultPoints = [
    { lat: 28.55108, lng: 77.26913 },
    { lat: 28.55106, lng: 77.26906 },
    { lat: 28.55105, lng: 77.26897 },
    { lat: 28.55101, lng: 77.26872 },
    { lat: 28.55099, lng: 77.26849 },
    { lat: 28.55097, lng: 77.26831 },
    { lat: 28.55093, lng: 77.26794 },
    { lat: 28.55089, lng: 77.2676 },
    { lat: 28.55123, lng: 77.26756 },
    { lat: 28.55145, lng: 77.26758 },
    { lat: 28.55168, lng: 77.26758 },
    { lat: 28.55175, lng: 77.26759 },
    { lat: 28.55177, lng: 77.26755 },
    { lat: 28.55179, lng: 77.26753 },
  ];

  const points = pathPoints || defaultPoints;

  useEffect(() => {
    let isMounted = true;

    // Cleanup function
    const cleanup = () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
      if (polylineRef.current) {
        polylineRef.current = null;
      }
      mapplsInstanceRef.current = null;
    };

    // Initialize map
    const initializeMap = () => {
      try {
        // Create mappls instance
        const mapplsInstance = new mappls();
        mapplsInstanceRef.current = mapplsInstance;

        // Configure SDK
        const loadObject = {
          map: true,
          version: '3.0',
        };

        // Initialize with access token
        mapplsInstance.initialize(accessToken, loadObject, () => {
          if (!isMounted) return;

          // Create map
          const map = mapplsInstance.Map({
            id: "map",
            properties: {
              center: [28.61, 77.23],
              zoom: 14,
              zoomControl: true,
            },
          });

          mapInstanceRef.current = map;

          // Add listener for map load
          map.on("load", function() {
            if (!isMounted) return;

            setLoading(false);

            // Create polyline with animated marker
            const polyline = mapplsInstance.Polyline({
              map: map,
              paths: points,
              strokeColor: 'blue',
              strokeOpacity: 1.0,
              strokeWeight: 10,
              fitbounds: true,
              animate: {
                speed: 5,
                icon_width: 20,
                icon_height: 50,
                icon_url: "http://about.mappls.com/api/advanced-maps/doc/sample/map_sdk/car.png",
                repeat: true,
              },
            });

            polylineRef.current = polyline;
          });
        });

      } catch (err) {
        console.error('Error initializing map:', err);
        if (isMounted) {
          setError('Failed to initialize map: ' + err.message);
          setLoading(false);
        }
      }
    };

    // Initialize map if accessToken is provided
    if (accessToken) {
      initializeMap();
    } else {
      setError('Access token is required');
      setLoading(false);
    }

    // Cleanup on unmount
    return () => {
      isMounted = false;
      cleanup();
    };
  }, [accessToken, pathPoints]);

  // Update polyline when points change
  useEffect(() => {
    if (polylineRef.current && mapInstanceRef.current) {
      try {
        polylineRef.current.setPaths(points);
      } catch (err) {
        console.error('Error updating polyline:', err);
      }
    }
  }, [pathPoints]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
      <div
        id="map"
        ref={mapRef}
        style={{
          width: '100%',
          height: '100%',
          margin: 0,
          padding: 0,
        }}
      />
      
      {/* Loading Overlay */}
      {loading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.9)',
          zIndex: 1000,
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }} />
          <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>Loading map...</p>
        </div>
      )}

      {/* Error Overlay */}
      {error && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.95)',
          zIndex: 1000,
          padding: '20px',
        }}>
          <div style={{
            color: '#e74c3c',
            fontSize: '48px',
            marginBottom: '10px',
          }}>⚠️</div>
          <h3 style={{ color: '#333', marginBottom: '10px' }}>Map Error</h3>
          <p style={{ color: '#666', textAlign: 'center', maxWidth: '400px' }}>{error}</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 24px',
              background: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Retry
          </button>
        </div>
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default AnimatedMap;